var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.231 12.625H.768c-.286 0-.518.246-.518.547 0 .301.232.547.518.547h16.463c.286 0 .519-.246.519-.547 0-.301-.233-.547-.519-.547M.25.672C.25.37.482.125.768.125h16.463c.287 0 .519.246.519.547 0 .301-.232.547-.519.547H.768C.482 1.219.25.973.25.672m16.981 5.703H.768c-.286 0-.518.246-.518.547 0 .301.232.547.518.547h16.463c.286 0 .519-.246.519-.547 0-.301-.233-.547-.519-.547"
  })));
};
export default SvgBurger;